import { gablePedimentSideConfigs, type GablePedimentSideConfig } from '../../ssb_constants';

/**
 * Maps one configured displayed side to the runtime metadata used to render and place a gable pediment.
 *
 * @param displayedSide - The displayed side key loaded from settings.
 * @returns The normalized side config, or null when the side is unsupported.
 */
export const getGablePedimentSideConfig = (
	displayedSide: string,
): GablePedimentSideConfig | null => {
	return gablePedimentSideConfigs[displayedSide] || null;
};

/**
 * Resolves valid gable pediment side configs while preserving order and removing duplicates.
 *
 * @param displayedSides - The displayed side values loaded from settings.
 * @returns The normalized side configs that should receive rendered pediment clones.
 */
export const getConfiguredGablePedimentSideConfigs = (
	displayedSides: unknown[] = [],
): GablePedimentSideConfig[] => {
	const sideConfigs: GablePedimentSideConfig[] = [];
	const addedSides = new Set<string>();

	displayedSides.forEach((displayedSide) => {
		const normalizedSide = String(displayedSide || '');
		const sideConfig = getGablePedimentSideConfig(normalizedSide);

		if (!sideConfig || addedSides.has(sideConfig.side)) {
			return;
		}

		addedSides.add(sideConfig.side);
		sideConfigs.push(sideConfig);
	});

	return sideConfigs;
};
